<script setup>
import { ref, computed,watch } from 'vue';
import { useQuasar, QVideo } from 'quasar';
const $q = useQuasar();
const darkMode = ref($q.dark.isActive);

watch(() => $q.dark.isActive, (newVal) => {
    darkMode.value = newVal;
});
const isLargeScreen = computed(() => $q.screen.gt.xs);
const videoVisible = ref(false);


useHead({
    title: 'Recognizing Independent Labs That Stand Out',
    meta: [
        { name: 'description', content: 'Article from Essilor about 2019 independent lab awards.' }
    ]
})
</script>

<template>
    <div class="row justify-center q-mt-lg q-mb-lg" style="margin-top: 40px;">
        <div class="col-11 col-md-6">
            <div :class="['text-h3 text-left', darkMode ? 'text-grey-5' : 'text-brand']"><strong>Recognizing Independent Labs That Stand Out</strong></div>
            <div :class="['text-h3 text-left', darkMode ? 'text-grey-5' : 'text-brand']">By Essilor News</div>
            <div :class="['text-h3 text-left', darkMode ? 'text-grey-5' : 'text-brand']">Essilor News - 2019</div>
            <div style="font-size: 18px;">
                <a :class="darkMode ? 'text-grey-5' : ''" href="https://www.essilorpro.com/insights/recognizing-independent-labs-that-standout"
                    target="_blank">https://www.essilorpro.com/insights/recognizing-independent-labs-that-standout</a>
            </div>

            <br>
            <div :class="darkMode ? 'text-grey-5' : 'text-brand'">
                <p style="font-size: 20px;">Independent Distribution Division (IDD), a business unit within Essilor of
                    America that supports independently owned and operated optical labs, strives to make the difference
                    for our industry, our customers, and, most importantly, for those whose lives are forever changed by
                    the right pair of glasses. The IDD team works with 185 independent labs with over 250 lab locations
                    around the country, empowering them with products, programs and strategies to grow their business.
                </p>
                <p style="font-size: 20px;">Each year at Essilor’s National Sales Meeting, IDD hosts the Vision
                    Excellence Awards to present their annual laboratory awards, recognizing independent distributors
                    who have exceeded expectations and achieved top sales performance in both sales and unit growth
                    within specific Essilor product categories.</p>
                <p style="font-size: 20px;">John Walborn, Senior Vice President Wholesale Business, along with other
                    Wholesale Business leaders, presented this year’s awards. “Our independent laboratory partners
                    continue to deliver superb products and services to our customers and their patients,” Walborn said
                    as he congratulated the winners. “We greatly appreciate their continued commitment to innovation,
                    superior service and delivering the best vision solutions and experience possible.”.</p>
                <p style="font-size: 20px;">The following independent laboratory partners and retailers received awards
                    for outstanding achievements in the following categories:</p>
                <p style="font-size: 20px;">
                    <strong>Essilor IDD Lab of the Year</strong><br>

                    Cherry Optical, Inc. <br>

                    <strong>Varilux® Award of Excellence</strong> <br>

                    Green Optics <br>

                    <strong>Crizal® Award of Excellence</strong> <br>

                    Perfect Optical <br>

                    <strong>Essilor Transitions® Award of Excellence</strong> <br>

                    Walman Optical <br>

                    <strong>Essilor Xperio UV™ Award of Excellence</strong> <br>

                    Cherry Optical, Inc. <br><br>

                    Non-sales related awards were also given out: <br><br>

                    <strong>Essilor IDD Very Important Partner Award for Managed Vision Care Labs</strong> <br>

                    Scott Hamey, Versant Health <br>

                    <strong>Essilor IDD Very Important Partner Award for National Labs</strong> <br>

                    Adam Cherry, Cherry Optical, Inc. <br>

                    <strong>Essilor IDD Very Important Partner Award for Wholesale Labs</strong> <br>

                    Mike Shane, OnSight Optical
                </p>

            </div>
        </div>
    </div>
</template>
